import { render, staticRenderFns } from "./NewEditTurmaPage.vue?vue&type=template&id=0333139a"
import script from "./NewEditTurmaPage.vue?vue&type=script&lang=js"
export * from "./NewEditTurmaPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditTurmaPage.vue?vue&type=style&index=0&id=0333139a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports